import { gql } from '@apollo/client';

export const ADD_EVENT = gql`
    mutation addEvent(
        $name: String!,
        $url: String!,
        $customer: String!,
        $startDatetime: String!,
        $duration: Int!,
        $coordinatorName: String!,
        $coordinatorEmail: String!,
        $coordinatorPassword: String!,
        $gameId: Int!,
        $teamsLimit: Int!,
        $maxPlayersInTeam: Int!,
        $description: String!,
        $slackChannelName: String!,
    ) {
        addEvent(
            name: $name,
            url: $url,
            customer: $customer,
            startDatetime: $startDatetime,
            duration: $duration,
            coordinatorName: $coordinatorName,
            coordinatorEmail: $coordinatorEmail,
            coordinatorPassword: $coordinatorPassword,
            gameId: $gameId,
            teamsLimit: $teamsLimit,
            maxPlayersInTeam: $maxPlayersInTeam,
            description: $description,
            slackChannelName: $slackChannelName,
        ) {
            id
        }
    }
`;
